import React, { useEffect, useState } from 'react'
import { Badge, Col, Descriptions, Row, Space } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { LoadingView } from 'Components/modal'
import { formatDateTime, getDiffDay, numberWithComma } from 'helpers/format'
import Theme, { MyTheme } from 'Components/common/Theme'
import { packageSpecByIDAPI } from 'Store/pos/api'
import { PackagesSpecByIDReq } from 'Store/pos/types'
import { selectPackagesSpecByID } from 'Store/pos/selector'
import { StatusTag } from 'Components/utilities'
import PackageLog from './PackageLog'

type Props = {
  isShow: boolean
  onClose: () => void
  id: number
} & ReduxProps

const PackageDetail = (props: Props) => {
  const { isShow, onClose, currentUser, id, packageSpecByID } = props
  const [drawer, setDrawer] = useState(false)

  const dispatch = useDispatch()

  const onGetDataList = (): void => {
    const req: PackagesSpecByIDReq = {
      id: id,
    }
    dispatch(packageSpecByIDAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    if (isShow) {
      onGetDataList()
    }
  }, [isShow, id])

  const renderStatus = (activate: boolean) => (
    <StatusTag isPass={activate} text={activate ? 'ใช้งาน' : 'ไม่ใช้งาน'} />
  )

  const data = packageSpecByID?.data
  let remainDay = 0
  if (data?.end_date != '') {
    remainDay = getDiffDay(data?.end_date || '').toFixed(0)
  } else {
    remainDay = data?.day
  }

  const PackageLogDrawer = <PackageLog id={id} isShow={drawer} onClose={() => setDrawer(false)} />
  const title = (
    <div>
      รายละเอียดแพ็กเกจ &nbsp;
      <TextLink onClick={() => setDrawer(true)}>ดูประวัติการซื้อ</TextLink>
    </div>
  )

  return (
    <DetailDrawer
      title={title}
      width={'50%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={packageSpecByID.event.IsLoading} />
      {PackageLogDrawer}
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Descriptions title="" bordered>
            <Descriptions.Item label="ชื่อแพ็กเกจ" span={3}>
              <Text>{data?.name || ''}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="รายละเอียดแพ็กเกจ" span={3}>
              <Space direction="vertical">
                {packageSpecByID &&
                  packageSpecByID.data &&
                  packageSpecByID.data?.properties.map((item: string, index: number) => {
                    return <TextBadge key={index} color={Theme.colors.drakGrey} text={item} />
                  })}
              </Space>
            </Descriptions.Item>
            <Descriptions.Item label="จำนวนผู้ใช้งานสูงสุด" span={3}>
              <Text>{numberWithComma(data?.limit_staff || 0)} คน</Text>
            </Descriptions.Item>
            <Descriptions.Item label="จำนวนเครื่อง Terminal ที่ใช้งานสูงสุด" span={3}>
              <Text>{numberWithComma(data?.limit_terminal || 0)} เครื่อง</Text>
            </Descriptions.Item>
            <Descriptions.Item label="วันที่เริ่มใช้งาน" span={3}>
              <Text>{formatDateTime(data?.start_date || '') || '-'}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="วันที่หมดอายุ" span={3}>
              <Text>{formatDateTime(data?.end_date || '') || '-'}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="จำนวนวันใช้งานคงเหลือ" span={3}>
              <Text>{remainDay < 0 ? 0 : Math.abs(remainDay)} วัน</Text>
            </Descriptions.Item>
            <Descriptions.Item label="สถานะ" span={3}>
              <Text>{renderStatus(data?.activate || false)}</Text>
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const TextBadge = styled(Badge)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4} !important;
  text-align: left;
  .ant-badge-status-text {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  }
`

const Text = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const TextLink = styled.span`
  cursor: pointer;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    packageSpecByID: selectPackagesSpecByID(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PackageDetail)
